<template>
  <div class="introduce_page">
    <img v-for="v in 31" :key="v" :src="`http://app.qcql.cn/img/productConfigImg/产品配置表_${v < 10 ? '0'+v : v}.jpg`" class="introduce_img"/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shareConfig: {
        imgUrl: 'https://toro.e5ex.com/logo.png',
        title: document.title,
        desc: '',
        link: window.location.href,
      }
    };
  },
  created() {
  },
  mounted(){
  },
  methods: {
    toMiniapp() {
      // document.title = '轮端感知信息牌';
      const params = {
        url: window.location.href.split('/#/')[0],
        sn: window.location.href.split('/#/')[1]
      }
      getSign(params).then(({code, msg, data}) => {
        if (!code) {
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.isResponse = true;
          this.appLogo = data.logo;
          // document.title = this.AppName;
          this.plate = data.plate;
          this.parentNumber = data.parentNumber;
          this.snCode = data.Sn;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            // jsApiList: ['onMenuShareAppMessage'],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
            wx.onMenuShareAppMessage(this.shareConfig);
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
  }
}
</script>
<style scoped>
.introduce_img{
  width: 100%;
  height: auto;
}
.introduce_icon{
  width: 60%;
  display: block;
  margin: 50px auto;
}
.introduce_wrap{
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
}
.introduce_wrap_item{
  width: calc(33.3vw - 14px);
  height: calc(33.33vw - 10px);
  margin: 5px;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 2px #CCCCCC;
}
.introduce_wrap_item img{
  width: 100%;
  height: auto;
}
.introduce_wrap_item div{
  position: absolute;
  bottom: 10px;
  left: 0px;
  padding: 0 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 1; 
  overflow: hidden;
  text-align: center;
  width: 100%;
  color: #4d70ff;
  box-sizing: border-box;
  text-decoration: underline;
  font-size: 13px;
}
.introduce_wrap_item:visited div{
  color: #4007a2;
}
</style>



// WEBPACK FOOTER //
// src/components/productConfig.vue